// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_c0-0";
export var fileCarousel = "_c0-2";
export var removeFileButton = "_c0-1";